import type { Language } from '@seek/melways-sites';
import type { IJobApplicationStore } from './index';
import type { FiltersEventCaptureData } from 'src/services/jobApplicationService/buildCaptureEventData';
import type { SearchFilters } from './types';
import type { TrackingExperimentsAttributes } from 'src/utils/eventsTypes';

export const updateApplicationList = async (
  jobApplicationStore: IJobApplicationStore,
  initialLoad: boolean,
  language: Language,
  filters: SearchFilters,
  experiments?: TrackingExperimentsAttributes[],
) => {
  const { uiState, lastResultSearchText, bucket, loadJobApplications } =
    jobApplicationStore;

  if (uiState.search) {
    if (uiState.search !== lastResultSearchText) {
      await loadJobApplications({
        searchText: uiState.search,
        page: uiState.page,
        language,
        filters,
        experiments,
      });
    }
    return;
  }

  if (initialLoad || uiState.bucket !== bucket || lastResultSearchText !== '') {
    await loadJobApplications({
      bucket: uiState.bucket,
      page: uiState.page,
      language,
      filters,
      experiments,
    });
  }
};

export const updatePage = async (
  jobApplicationStore: IJobApplicationStore,
  language: Language,
  filters: SearchFilters,
  experiments?: TrackingExperimentsAttributes[],
) => {
  const { uiState, currentPage } = jobApplicationStore;

  if (uiState.page !== currentPage) {
    await jobApplicationStore.loadJobApplications({
      page: uiState.page,
      language,
      filters,
      experiments,
    });
  }
};

export const updateOverlay = async (
  jobApplicationStore: IJobApplicationStore,
) => {
  const { uiState } = jobApplicationStore;

  if (uiState.overlay) {
    jobApplicationStore.showOverlay(uiState.overlay);
  } else {
    jobApplicationStore.hideOverlay();
  }
};

export const updateSelectedDetails = async (
  jobApplicationStore: IJobApplicationStore,
  initialLoad: boolean,
  language: Language,
  filtersEventCaptureData: FiltersEventCaptureData,
) => {
  const { uiState, showDetails, hideDetails } = jobApplicationStore;
  const { selectedProspectId, tab } = uiState;

  if (selectedProspectId) {
    await showDetails({
      id: selectedProspectId,
      language,
      initialLoad,
      tab,
      filtersEventCaptureData,
    });
  } else {
    hideDetails();
  }
};
